import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDontBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDoAndDontBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 16v7a4 4 0 0 0 4 4h7v-2H9a2 2 0 0 1-2-2v-7zm11-9h7a2 2 0 0 1 2 2v7h2V9a4 4 0 0 0-4-4h-7zm11.792 12.735a1 1 0 0 1 0 1.414l-4.507 4.507-.707.707-.707-.707-2.345-2.346a1 1 0 0 1 1.414-1.414l1.638 1.638 3.8-3.8a1 1 0 0 1 1.414 0M6.182 6.182a1 1 0 0 1 1.414 0L9.364 7.95l1.768-1.768a1 1 0 1 1 1.414 1.414l-1.768 1.768 1.768 1.768a1 1 0 1 1-1.414 1.414l-1.768-1.768-1.768 1.768a1 1 0 1 1-1.414-1.414L7.95 9.364 6.182 7.596a1 1 0 0 1 0-1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDontBox32);
